/* eslint-disable no-shadow */
const state = {
  color: null,
  type: null,
  message: null,
};

const actions = {
  success({ commit }, message) {
    // eslint-disable-next-line quotes
    commit("success", message);
  },
  info({ commit }, message) {
    // eslint-disable-next-line quotes
    commit("info", message);
  },
  error({ commit }, message) {
    commit("error", message);
  },
  clear({ commit }) {
    commit("clear");
  },
};

const mutations = {
  success(state, message) {
    state.color = "green";
    state.type = "success";
    state.message = message;
  },
  info(state, message) {
    state.color = "blue";
    state.type = "info";
    state.message = message;
  },
  error(state, message) {
    state.color = "red";
    state.type = "danger";
    state.message = message;
  },
  clear(state) {
    state.color = "xxx";
    state.type = null;
    state.message = null;
  },
};

const snackbar = {
  namespaced: true,
  state,
  actions,
  mutations,
};

export default snackbar;
